import React from 'react'
import { UnsubmittedWeek } from '@/services/timesheetService'
import UnsubmittedWeekAlert from './UnsubmittedWeekAlert'

interface UnsubmittedWeeksSectionProps {
  unsubmittedWeeks: UnsubmittedWeek[]
  onCreateTimesheet: (weekStart: string) => void
  loading?: boolean
}

const UnsubmittedWeeksSection: React.FC<UnsubmittedWeeksSectionProps> = ({
  unsubmittedWeeks,
  onCreateTimesheet,
  loading = false
}) => {
  if (loading) {
    return (
      <div className="space-y-4 mb-6">
        {[...Array(2)].map((_, index) => (
          <div key={index} className="card p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded mb-4 w-1/3"></div>
            <div className="h-3 bg-gray-200 rounded mb-2 w-2/3"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        ))}
      </div>
    )
  }

  if (unsubmittedWeeks.length === 0) {
    return null
  }

  return (
    <div className="space-y-4 mb-6">
      {unsubmittedWeeks.map(week => (
        <UnsubmittedWeekAlert
          key={week.weekStart}
          week={week}
          onCreateTimesheet={onCreateTimesheet}
        />
      ))}
    </div>
  )
}

export default UnsubmittedWeeksSection
